import "core-js/modules/es6.function.name";
import { Box } from '@origin-digital/layout';
import * as React from 'react';
import styled from 'styled-components';
import { AnimationHeadShake } from '../../../animation';
import { Colors, FontWeights } from '../../../../consts';
import Markdown from '../../../Text/Markdown';
var Container = styled(Box).withConfig({
  displayName: "HelpText__Container",
  componentId: "oipmp0-0"
})(["margin-right:12px;margin-left:12px;margin-top:", "px;line-height:20px;color:", ";"], function (_ref) {
  var radio = _ref.radio;
  return radio ? '-6' : '4';
}, function (_ref2) {
  var disabled = _ref2.disabled;
  return !disabled ? 'rgba(115,115,115)' : 'rgba(115,115,115,.5)';
});
var StyledText = styled.span.withConfig({
  displayName: "HelpText__StyledText",
  componentId: "oipmp0-1"
})(["font-size:12px;line-height:20px;font-weight:", ";display:inherit;a:visited,a:link,a:hover,a:active{font-size:inherit;line-height:inherit;color:inherit;font-weight:600;}white-space:pre-line;margin-left:", ";color:", ";"], FontWeights.REGULAR, function (_ref3) {
  var radio = _ref3.radio;
  return radio ? '22px' : '0px';
}, function (_ref4) {
  var showError = _ref4.showError,
      disabled = _ref4.disabled;
  return showError ? disabled ? 'rgba(230, 0, 0, 0.5)' : Colors.RED : disabled ? 'rgba(115,115,115,.5)' : 'rgba(115,115,115,1)';
});

var Text = function Text(_ref5) {
  var markdown = _ref5.markdown,
      dataId = _ref5.dataId,
      children = _ref5.children,
      disabled = _ref5.disabled,
      _ref5$showError = _ref5.showError,
      showError = _ref5$showError === void 0 ? false : _ref5$showError,
      radio = _ref5.radio;
  var content = markdown && typeof children === 'string' ? React.createElement(Markdown, {
    markdown: true
  }, children) : children;
  return React.createElement(StyledText, {
    "data-id": dataId,
    disabled: disabled,
    showError: showError,
    radio: radio
  }, content);
};

var HelpText = function HelpText(_ref6) {
  var error = _ref6.error,
      _ref6$showError = _ref6.showError,
      showError = _ref6$showError === void 0 ? false : _ref6$showError,
      _ref6$helpText = _ref6.helpText,
      helpText = _ref6$helpText === void 0 ? '' : _ref6$helpText,
      disabled = _ref6.disabled,
      characterCount = _ref6.characterCount,
      radio = _ref6.radio,
      name = _ref6.name,
      _ref6$markdown = _ref6.markdown,
      markdown = _ref6$markdown === void 0 ? false : _ref6$markdown;
  return React.createElement(Container, {
    display: "flex",
    direction: "row",
    justifyContent: "between",
    minHeight: 20,
    radio: radio
  }, React.createElement(Box, null, showError ? React.createElement(AnimationHeadShake, {
    "data-id": name + 'Error',
    duration: "0.8s",
    delay: "0"
  }, React.createElement(Text, {
    dataId: name + 'ErrorText',
    markdown: markdown,
    disabled: disabled,
    showError: showError,
    radio: radio
  }, error)) : React.createElement(Text, {
    dataId: name + 'HelpText',
    markdown: markdown,
    disabled: disabled,
    radio: radio
  }, helpText)), React.createElement(Box, {
    "data-id": name + 'CharacterCount'
  }, characterCount && React.createElement(StyledText, {
    disabled: disabled,
    showError: showError
  }, characterCount.currentLength, "/", characterCount.maxLength)));
};

export { HelpText };